const guiColors = {
    'looks-secondary': 'hsla(215, 100%, 65%, 1)',
    'looks-secondary-light': 'hsl(215,100%,85%)',
    'looks-secondary-lighter': 'hsl(214,100%,95%)',
    'looks-transparent': 'hsla(215, 100%, 65%, 0.35)',
    'looks-light-transparent': 'hsla(215, 100%, 65%, 0.15)',
    'looks-secondary-dark': 'hsla(215, 60%, 50%, 1)',
    'looks-secondary-darker': 'hsl(215,62%,31%)',
    'looks-secondary-deep-dark': 'hsl(215,64%,18%)'
};

const blockColors = {};

export {
    guiColors,
    blockColors
};
